import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, } from 'react';
import { Paper, Table, TableRow, TableCell, TableHead, Icon, TableBody, makeStyles, CircularProgress, Button, Menu, MenuItem, Box, Hidden, IconButton, } from '@material-ui/core';
import clsx from 'clsx';
import { createHeaderColumn, SearchBox, useModeTableStyle, useModePanelStyle, useDropdown, CompPanelHeader, createPreviewItemCell, createRemoveItemCell, } from '@moderepo/mode-app-components';
const useStyle = makeStyles((theme) => {
    return {
        filter: {
            '&:not(:last-child)': {
                marginRight: theme.spacing(2),
            },
            '& .label': {
                display: 'flex',
                textTransform: 'none',
                flexDirection: 'column',
                alignItems: 'flex-start',
                '& .filter-label': {
                    fontWeight: 'normal',
                    fontSize: 'smaller',
                    color: theme.palette.text.secondary,
                    lineHeight: '1em',
                },
                '& .filter-value': {
                    color: theme.palette.text.primary,
                },
            },
        },
        searchBoxContainer: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'unset',
                marginLeft: theme.spacing(2),
                maxWidth: '20em',
            },
            [theme.breakpoints.up('md')]: {
                minWidth: '20em',
            },
        },
        panelContent: {
            padding: 0,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        tableContainer: {
            overflow: 'auto',
            flex: 1,
        },
        tableCol: {
            '&.id-col': {
                textAlign: 'center',
            },
            '&.deviceClass-col': {
                textAlign: 'left',
            },
            '&.tag-col': {
                textAlign: 'left',
                width: '50%',
            },
            '&.name-col': {
                textAlign: 'left',
                width: '50%',
            },
            '&.homeId-col': {
                textAlign: 'center',
            },
            '&.status-col': {
                textAlign: 'center',
                '& .value': {
                    fontSize: 'smaller',
                    fontWeight: 500,
                    padding: theme.spacing(0.3, 1),
                    borderRadius: 100,
                    textTransform: 'lowercase',
                    background: theme.palette.info.main,
                    color: theme.palette.info.contrastText,
                    width: '100%',
                    display: 'inline-block',
                },
                '&.connected': {
                    '& .value': {
                        background: theme.palette.success.main,
                        color: theme.palette.success.contrastText,
                    },
                },
                '&.disconnected': {
                    '& .value': {
                        background: theme.palette.error.main,
                        color: theme.palette.error.contrastText,
                    },
                },
            },
            '&.createdDate-col': {
                textAlign: 'left',
            },
            '&.connectivityDate-col': {
                textAlign: 'left',
            },
            '&.claimTime-col': {
                textAlign: 'left',
            },
            '&.availability-col': {
                textAlign: 'center',
                '&.available': {
                    '& .value': {
                        color: theme.palette.success.main,
                    },
                },
                '&.not-available': {
                    '& .value': {
                        color: theme.palette.error.main,
                    },
                },
            },
        },
    };
}, {
    name: 'ProjectDevicesTable', index: 1,
});
/**
 * This is a DUMB component that is in charge of displaying the list of devices with pagination. All this component does is display data
 * provided through props. This component does not have any logic and any user action will be dispatched to the container's handlers.
 */
export const ProjectDevicesTable = (props) => {
    const [deviceClassMenuAnchorEl, isDeviceClassMenuOpened, onDeviceClassMenuAnchorClicked, onDeviceClassMenuClosed] = useDropdown();
    const tableClasses = useModeTableStyle();
    const panelClasses = useModePanelStyle();
    const classes = useStyle();
    /**
     * Get the label of the currently selected option so we can display the selected value in the dropdown
     */
    const currentDeviceClassLabel = useMemo(() => {
        if (props.deviceClasses) {
            const selectedOption = props.deviceClasses.find((option) => {
                return option.selected;
            });
            return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || '';
        }
        return '';
    }, [props.deviceClasses]);
    return (_jsxs(Paper, { elevation: 2, className: clsx(panelClasses.root, props.className, props.showCustomActionOnHover && 'show-custom-action-on-hover'), children: [_jsx(CompPanelHeader, { ...props, customContent: (_jsxs(_Fragment, { children: [props.showSearchOption && (_jsx("div", { className: classes.searchBoxContainer, children: _jsx(SearchBox, { placeholder: props.texts.search, onChange: (value) => {
                                    if (props.onSearchTextChange) {
                                        props.onSearchTextChange(value);
                                    }
                                } }) })), props.showDeviceClassesOption && (_jsxs(_Fragment, { children: [_jsx(Hidden, { xsDown: true, children: _jsx(Button, { className: classes.filter, onClick: onDeviceClassMenuAnchorClicked, endIcon: _jsx(Icon, { children: "arrow_drop_down" }), children: _jsxs("div", { className: "label", children: [_jsx("div", { className: "filter-label", children: props.texts.deviceClass }), _jsx("div", { className: "filter-value", children: currentDeviceClassLabel })] }) }) }), _jsx(Hidden, { smUp: true, children: _jsx(IconButton, { className: classes.filter, onClick: onDeviceClassMenuAnchorClicked, children: _jsx(Icon, { children: "filter_list" }) }) }), _jsx(Menu, { getContentAnchorEl: null, anchorEl: deviceClassMenuAnchorEl, anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }, transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }, keepMounted: true, open: isDeviceClassMenuOpened, onClose: onDeviceClassMenuClosed, children: props.deviceClasses.map((option) => {
                                        return (_jsx(MenuItem, { selected: option.selected, onClick: () => {
                                                onDeviceClassMenuClosed();
                                                if (props.onDeviceClassSelected) {
                                                    props.onDeviceClassSelected(option.value);
                                                }
                                            }, children: option.label }, option.label));
                                    }) })] }))] })) }), _jsxs("div", { className: clsx(panelClasses.panelContent, classes.panelContent), children: [props.listData && props.listData.length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.tableContainer, children: _jsxs(Table, { className: tableClasses.root, size: "medium", children: [_jsx(TableHead, { className: tableClasses.tableHeader, children: _jsx(TableRow, { className: tableClasses.tableHeaderRow, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                                                    var _a;
                                                    return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                                                }).map((fieldName) => {
                                                    const field = props.fieldsSettings.fields[fieldName];
                                                    if (field && !field.hidden) {
                                                        return createHeaderColumn(props.fieldsSettings, fieldName, field, `${tableClasses.tableCol} ${classes.tableCol} ${fieldName}-col`);
                                                    }
                                                    return _jsx(_Fragment, {});
                                                }) }) }), _jsx(TableBody, { children: props.listData.map((dataItem) => {
                                                return (_jsx(TableRow, { className: clsx(tableClasses.tableBodyRow, 'clickable', dataItem.selected && 'selected'), onClick: () => {
                                                        if (props.onListItemSelected) {
                                                            props.onListItemSelected(dataItem.actualValue);
                                                        }
                                                    }, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                                                        var _a;
                                                        return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                                                    }).map((fieldName) => {
                                                        if (fieldName === 'status' && props.fieldsSettings.fields.status
                                                            && !props.fieldsSettings.fields.status.hidden) {
                                                            return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`, dataItem.actualValue.isConnected ? 'connected' : 'disconnected'), children: _jsx("div", { className: "value", children: dataItem.displayValue.status }) }, fieldName));
                                                        }
                                                        if (fieldName === 'availability' && props.fieldsSettings.fields.availability
                                                            && !props.fieldsSettings.fields.availability.hidden) {
                                                            return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`, dataItem.displayValue.availability && 'available', !dataItem.displayValue.availability && 'not-available'), children: _jsx("div", { className: "value", children: dataItem.displayValue.availability
                                                                        ? _jsx(Icon, { className: "not-available", children: "check" })
                                                                        : _jsx(Icon, { className: "available", children: "not_interested" }) }) }, fieldName));
                                                        }
                                                        if (fieldName === 'remove' && props.fieldsSettings.fields.remove
                                                            && !props.fieldsSettings.fields.remove.hidden) {
                                                            return (
                                                            // NOTE: dataItem.canBeRemoved must be true
                                                            createRemoveItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onRemoveItemClicked));
                                                        }
                                                        if (fieldName === 'preview' && props.fieldsSettings.fields.preview
                                                            && !props.fieldsSettings.fields.preview.hidden) {
                                                            return createPreviewItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onPreviewItemClicked);
                                                        }
                                                        /**
                                                         * Handle all the other fields that don't have special UI. These are the fields that
                                                         * display dataItem.displayValue as plain text
                                                         */
                                                        if (props.fieldsSettings.fields[fieldName]
                                                            && !props.fieldsSettings.fields[fieldName].hidden) {
                                                            return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), children: dataItem.displayValue[fieldName] }, fieldName));
                                                        }
                                                        return _jsx(_Fragment, {});
                                                    }) }, dataItem.actualValue.id));
                                            }) })] }) }), props.paginationComp] })), props.listData && props.listData.length === 0 && props.emptyDataMessageComp, !props.listData && (_jsx(Box, { padding: 2, children: _jsx(CircularProgress, {}) }))] })] }));
};
